module.exports = __webpack_public_path__ + "c06e8737d07c5421196341df242a0b80.png";